import { useLang } from "@/context/LangContext";
import { Link } from "react-router-dom";
import { HardHat } from "lucide-react";

const SUPPORT_EMAIL = "support@urbis.shop";

export default function Footer() {
  const { t, lang, logo } = useLang();
  const es = lang === "es";
  const links = [
    { to: "/manual", label: es ? "Manual de usuario" : "User manual" },
    { to: "/support", label: es ? "Centro de soporte" : "Support center" },
    { to: "/terms", label: es ? "Términos de uso" : "Terms of use" },
    { to: "/privacy", label: es ? "Privacidad" : "Privacy" },
    { to: "/legal", label: es ? "Aviso legal y cookies" : "Legal & cookies" },
  ];
  return (
    <footer className="border-t border-slate-800 bg-secondary text-slate-300">
      <div className="mx-auto max-w-7xl px-6 py-12">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
          <div className="flex items-center gap-2">
            {logo ? (
              <img src={logo} alt={t("brand")} className="h-11 w-auto max-w-[200px] object-contain" data-testid="footer-logo" />
            ) : (
              <>
                <span className="flex h-8 w-8 items-center justify-center rounded-sm bg-primary text-white"><HardHat className="h-4 w-4" /></span>
                <span className="font-head text-lg font-extrabold text-white">{t("brand")}</span>
              </>
            )}
          </div>
          <nav className="flex flex-wrap gap-x-6 gap-y-2" data-testid="footer-links">
            {links.map((l) => (
              <Link key={l.to} to={l.to} className="text-sm text-slate-400 transition-colors hover:text-white" data-testid={`footer-link-${l.to.slice(1)}`}>{l.label}</Link>
            ))}
            <a href={`mailto:${SUPPORT_EMAIL}`} className="text-sm text-slate-400 transition-colors hover:text-white" data-testid="footer-email">{SUPPORT_EMAIL}</a>
          </nav>
        </div>
        <p className="mt-8 border-t border-slate-800 pt-6 text-sm text-slate-400">
          © {new Date().getFullYear()} {t("brand")}. {t("footer_rights")}
        </p>
      </div>
    </footer>
  );
}
